import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FamilyInfo from '../components/FamilyInfo';
import StudentsList from '../components/StudentsList';
import api from '../services/api';

export default function Dashboard() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [familyData, setFamilyData] = useState(null);

  useEffect(() => {
    const fetchFamilyData = async () => {
      try {
        const response = await api.get('/family');
        setFamilyData(response.data.data);
      } catch (err) {
        setError('Failed to load family information');
        console.error('Failed to fetch family data:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFamilyData();
  }, []);

  if (error) {
    return (
      <div className="space-y-6">
        <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
          <div className="text-red-600 dark:text-red-400">{error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <FamilyInfo 
        familyName={familyData?.family_name ?? null}
        phone={familyData?.phone_number ?? null}
        country={familyData?.country ?? null}
        state={familyData?.state ?? null}
        isLoading={isLoading}
      />
      <StudentsList 
        students={familyData?.students ?? []}
        onSelectStudent={(name) => navigate(`/students/${encodeURIComponent(name)}`)}
        isLoading={isLoading}
      />
    </div>
  );
}